module.exports = __webpack_public_path__ + "img/helpbox-3.ce6676e3.png";